import $ from "jquery";
import { Klass, u_ } from "@pressmedia/webappbase";
import vuwer from "@pressmedia/vuwer";

/**
* VuwLinkset for VuwLinkField (extends VuwField)
* @options
* - {Object} caption: keys->[name, required, ltd, placeholder]
* - {String} requiredText
*/
vuwer.appendKlass("VuwLinkset", {
	inpType: "set",
	defaultChildProp: {
		url: {
			vuwType: "textField",
			dataType: "url",
			placeholder: location.protocol + "//"
		},
		caption: {
			vuwType: "textField",
			onChangeState: function(state) {
				if( state.hasOwnProperty("disabled") && this.$self.hasClass("is-disable") !== state.disabled) {
					this.$self.toggleClass("is-disable", !!state.disabled);
					if( this.container.caption.placeholder &&
							(!this.getVal() || this.getVal() === this.container.caption.placeholder) ) {
						this.setVal(state.disabled ? "" : this.container.caption.placeholder, true);
					}
				}
			}
		}
	},
	
	_initialize: function _initialize(opt) {
		if( Klass("VuwLinkset").parent._initialize.call(this, opt) ) {
			this.add("url", Object.assign({}, this.defaultChildProp.url, {
				paramKey: this.paramKey
			}));
			
			if( u_.isObject(this.caption) ) {
				this.add("caption", Object.assign({}, this.defaultChildProp.caption, {
					paramKey: this.paramKey + "_cap",
					//required: !!this.caption.required,	requiredは動的に変更
					ltd: this.caption.ltd || 0
				}));
			}
			
			this.onReady(function() {
				var form = this.getForm();
				(form && form.config.requiredText) && (this.requiredText = form.config.requiredText);
				return this.renderField();
			});
			return this;
		} else {
			return false;
		}
	},
	
	getInpReady: function getInpReady($self) {
		$self.on("click", ".btn-del", function(e) {
			var vuw = $.data(e.delegateTarget, "vuw");
			e.preventDefault();
			if(vuw.container) {
				vuw.container.remove(vuw.name);
				!!vuw.container.$self && vuw.container.$self.removeClass("is-limit");
			}
		});
		
		if( this.get("caption") ) {
			this.$self.on("change", ".inp-url", function(e) {
				var
					vuw = $.data(e.delegateTarget, "vuw"),
					state = {
						disabled: !this.value
					};
				
				!!vuw.caption.required && (state.required = !!this.value);
				vuw.get("caption").setState(state);
			});
			
			return this.get("caption").setState("disabled", true);
		}
	},
	
	validate: function validate() {
		var err_cnt = 0;
		this.get("url").validate() || err_cnt++;
		if( this.get("caption") ) {
			this.get("caption").validate() || err_cnt++;
		}
		return !err_cnt;
	},
	
	setVal: function setVal(value, antiTriggerChange) {
		if( u_.isObject(value) ) {
			this.get("url").setVal(value.url || "", antiTriggerChange);
			if( u_.isObject(this.caption) ) {
				return this.get("caption").setVal(value.name || "", antiTriggerChange).setState("disabled", false);
			}
		} else {
			this.get("url").setVal("", antiTriggerChange);
			if( u_.isObject(this.caption) ) {
				return this.get("caption").setVal("", antiTriggerChange).setState("disabled", true);
			}
		}
		return this;
	},
	
	getVal: function getVal() {
		var val = {
			url: this.get("url").getVal()
		};
		if( u_.isObject(this.caption) ) {
			val.name = this.get("caption").getVal();
		}
		return val;
	},
	
	getCopiedElement: function getCopiedElement() {
		var $clone = Klass("VuwLinkset").parent.getCopiedElement.call(this).attr("id", null);
		!!$clone && $clone.children().wrapAll( $("<div/>").addClass("fields") );
		return $clone;
	},
	
	_getCopiedInp: function _getCopiedInp(val) {
		var clones = [];
		
		(val === undefined) && ( val = this.getVal() );
		
		if(u_.isObject(val) && u_.isString(val.url) && val.url) {
			clones.push( $("<a/>").addClass("replaced-inp").attr({
				href: val.url,
				title: decodeURIComponent(val.url),
				target: "_blank"
			}).append(
				$("<span/>").text( (u_.isString(val.name) && val.name) ? val.name : decodeURIComponent(val.url) )
			) );
		}
		
		return clones;
	},
	
	_renderField: function _renderField() {
		var $elm, vuwUrl, vuwCap, $lbl;
		
		$elm = $("<div/>").addClass("fields");
		
		vuwUrl = this.get("url");
		vuwUrl.$self = $("<var/>").appendTo($elm);
		vuwUrl.renderField();
		vuwUrl.$inp
		.attr("name", vuwUrl.$inp.attr("name").replace("_", "[") + "]")
		.before(
			$("<label/>").addClass("param-name").attr( "for", vuwUrl.$inp.attr("id") ).append(
				$("<span/>").text("URL")
			)
		);
		vuwUrl.$self.attr( "data-name", vuwUrl.$inp.attr("name") );
		
		vuwCap = this.get("caption");
		if(vuwCap) {
			vuwCap.$self = $("<var/>").appendTo($elm);
			vuwCap.renderField();
			vuwCap.$inp.attr("name", vuwCap.$inp.attr("name").replace("_", "--name[").replace(/_cap$/, "]"));
			vuwCap.$self.attr( "data-name", vuwCap.$inp.attr("name") ).addClass("field-cap");
			if( this.caption.name && u_.isString(this.caption.name) ) {
				$lbl = $("<label/>").addClass("param-name").attr( "for", vuwCap.$inp.attr("id") ).append(
					$("<span/>").text(this.caption.name)
				).insertBefore(vuwCap.$inp);
				
				if(this.caption.required) {
					$("<span/>").addClass("required").text(this.requiredText || "").appendTo($lbl);
				}
				
				if(this.caption.ltd) {
					$("<span/>").addClass("limit").attr("data-limit", this.caption.ltd).appendTo($lbl);
				}
			}
		}
		
		return $("<div/>").addClass("vuw-linkset").attr({
			"data-index": (this.name.indexOf("_") >= 0) ? this.name.split("_")[1] : "-1"
		}).append(
			$elm,
			$("<div/>").addClass("link-controller").append(
				$("<a/>").addClass("btn-del").attr({
					href: "./",
					title: "削除"
				}).append("<span/>")
			)
		);
	}
}, "VuwField");
